module.exports = __webpack_public_path__ + "static/img/1.9300bdb0.jpg";